import React from "react"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"

import HERO_BANNER_DATA from "../data/grocer-in-penang/herobanner"
import CAROUSEL_1 from "../data/grocer-in-penang/1Carousel"
import CAROUSEL_2 from "../data/grocer-in-penang/2Carousel"
import CAROUSEL_3 from "../data/grocer-in-penang/3Carousel"
import CAROUSEL_4 from "../data/grocer-in-penang/4Carousel"
import CAROUSEL_5 from "../data/grocer-in-penang/5Carousel"
import CAROUSEL_6 from "../data/grocer-in-penang/6Carousel"
import CAROUSEL_7 from "../data/grocer-in-penang/7Carousel"
import CAROUSEL_8 from "../data/grocer-in-penang/8Carousel"
import FAQ_DATA from "../data/grocer-in-penang/faq"

import Layout from "../components/layout"
import "../css/main.css"
import { fireGtmEvent } from "../utils/functions"

const ContentWrapper = styled.div`
  max-width: 625px;
  margin-bottom: 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 3em;

  @media only screen and (max-width: 720px) {
    width: 90%;
    margin: 2em auto;

    #title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 10px;
    }

    #subtitle {
      font-size: 16px;
      line-height: 20px;
    }
  }
`

const TextContentWrapper = styled.div`
  width: 90%;
  margin: 0 16px 24px;

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const GrocerInPenangPage = () => {
  return (
    <Layout title="Grocer In Penang"
            description="All stores on this page deliver within Penang Island with Free Delivery (min. spend RM60).Use promo code WELCOME10 to enjoy RM10 off your first order, valid for new users only."
            bannerData={HERO_BANNER_DATA}>
      <ContentWrapper>
        <TitleWrapper>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            type="h1"
            customProperties={{ id: "title" }}
          >
            airasia grocer is now in Penang!
          </Title>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            theme="AIRASIA_CLASSIC"
            type="h2"
            customProperties={{ id: "subtitle" }}
          >
            All stores on this page deliver within Penang Island with Free Delivery (min. spend RM60).<br/>
            Use promo code WELCOME10 to enjoy RM10 off your first order, valid for new users only.
          </Title>
        </TitleWrapper>
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_1.data}
          heading={CAROUSEL_1.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_2.data}
          heading={CAROUSEL_2.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_3.data}
          heading={CAROUSEL_3.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_4.data}
          heading={CAROUSEL_4.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_5.data}
          heading={CAROUSEL_5.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_6.data}
          heading={CAROUSEL_6.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_7.data}
          heading={CAROUSEL_7.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={true}
          data={CAROUSEL_8.data}
          heading={CAROUSEL_8.heading}
          isHideFooter={false}
          isLoading={false}
          templateType="productCard"
          fireGtm={fireGtmEvent}
          gtmConsumerName="Grocer Value Pack"
        />
      </ContentWrapper>
      <TextContentWrapper>
        <FAQ
          titleMarginBottom="normal"
          titleType="h3"
          title=""
          data={FAQ_DATA}
        />
      </TextContentWrapper>
    </Layout>
  )
}
export default GrocerInPenangPage
